import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {Trans, translate} from 'react-i18next';
import FormRegisterView from './FormRegisterView';

class MainRegisterView extends Component {

  render() {
    const {inProgress, t, registerData, errors, onCancel, handleSubmit, handleChange, passwordCallback, language} = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <div className="form__title form__title--has-lines">{t('new_account')}</div>
        <div className="form__helper">
          <Trans i18nKey="cancel_register">
            Already have an account?
            <Link to="#" onClick={onCancel}>
              Log in here
            </Link>
          </Trans>
        </div>
        <FormRegisterView
          state={registerData}
          errors={errors}
          handleChange={handleChange}
          passwordCallback={passwordCallback}
          language={language}
        />
        <div className="form__row">
          <div className='login__one-buttons'>
            <button
              className="form__button"
              type="submit"
              disabled={!registerData.isAgree || inProgress}>
              {t('create')}
            </button>
          </div>
        </div>
        {/*<div className="form__title form__title--has-lines form__title--offset-top">or</div>*/}
        {/*<div className="form__row">*/}
          {/*<button className="form__button form__button--social form__button--fb">*/}
            {/*Facebook Login*/}
          {/*</button>*/}
        {/*</div>*/}
        {/*<div className="form__row">*/}
          {/*<button className="form__button form__button--social form__button--google">*/}
            {/*Google login*/}
          {/*</button>*/}
        {/*</div>*/}
      </form>
    );
  }
}

MainRegisterView.propTypes = {
  errors: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
  inProgress: PropTypes.bool
};

export default translate('translations')(MainRegisterView);



// WEBPACK FOOTER //
// ./src/components/Customer/Auth/MainRegisterView.js